<template>
  <div class="nprogress-container"></div>
</template>

<script>
export default {
  name: 'nprogress-container'
};
</script>

<style lang="css">
@import '../../../node_modules/nprogress/nprogress.css';
</style>



// WEBPACK FOOTER //
// src/components/Modules/NprogressContainer.vue